"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');







// The file, not the folder index: the index also builds selectBlobjectMetadata on load.
var _common = require('shared/selectors/blobject/common/common');
var _common3 = require('shared/selectors/org/common');
var _team = require('shared/selectors/team');
var _user = require('shared/selectors/user');

const NO_TEMPLATES = []

/* The org's templates the signed-in user can see, by name, as last loaded. */
 const selectMessageTemplates = (state, orgKey) =>
  _nullishCoalesce(state.messageTemplates[orgKey], () => ( NO_TEMPLATES)); exports.selectMessageTemplates = selectMessageTemplates

const fullName = (p) => `${p.FirstName} ${p.LastName}`.trim().toLowerCase()

/* The chat's patients with their names, sorted by name. */
const selectChatPatients = _toolkit.createSelector.call(void 0, 
  [
    (state, blobjectKey) => _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _ => _.PatientSubscribers]),
    (state) => _optionalChain([state, 'optionalAccess', _2 => _2.dataV2, 'optionalAccess', _3 => _3.patients]),
    (state) => _optionalChain([state, 'optionalAccess', _4 => _4.patients]),
  ],
  (subscribers, v2, v1) =>
    (Object.keys(_nullishCoalesce(subscribers, () => ( {}))) )
      .map(key => {
        const patient = _nullishCoalesce(_optionalChain([v2, 'optionalAccess', _5 => _5[key]]), () => ( _optionalChain([v1, 'optionalAccess', _6 => _6[key]])))
        return { PatientKey: key, FirstName: _nullishCoalesce(_optionalChain([patient, 'optionalAccess', _7 => _7.FirstName]), () => ( '')), LastName: _nullishCoalesce(_optionalChain([patient, 'optionalAccess', _8 => _8.LastName]), () => ( '')) }
      })
      .sort((a, b) => fullName(a).localeCompare(fullName(b))),
)

const selectChatTeams = (state, blobjectKey) =>
  _optionalChain([_common.selectBlobjectByKey.call(void 0, state, blobjectKey), 'optionalAccess', _9 => _9.TeamSubscribers])

/* What a template's built-in variables are filled from in this chat: its
 * patients, the signed-in sender, the org and the chat's teams. */
 const selectTemplateContext = _toolkit.createSelector.call(void 0, 
  [
    selectChatPatients,
    (state) => _optionalChain([_user.selectCurrentUserV2.call(void 0, state), 'optionalAccess', _10 => _10.Name]),
    (state, _blobjectKey, orgKey) => _optionalChain([_common3.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _11 => _11.Name]),
    selectChatTeams,
    _team.selectTeams,
  ],
  (patients, senderName, orgName, chatTeams, teams) => ({
    patients,
    senderName,
    orgName,
    teamNames: Object.keys(_nullishCoalesce(chatTeams, () => ( {}))).map(key => _nullishCoalesce(_optionalChain([teams, 'access', _12 => _12[key ], 'optionalAccess', _13 => _13.Name]), () => ( ''))),
  }),
); exports.selectTemplateContext = selectTemplateContext
